import { Coffee, Martini, Sunrise } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const MOMENTS = [
  {
    time: "06:30",
    title: "La prima brioche & l'espresso",
    text: "Apriamo presto: il primo caffè della giornata profuma di casa.",
    icon: Sunrise,
  },
  {
    time: "10:30",
    title: "Il break del mattino",
    text: "Caffè e vetrina con salati.",
    icon: Coffee,
  },
  {
    time: "18:30",
    title: "L'aperitivo pesarese",
    text: "Spritz, taglieri e gli amici: si chiude a mezzanotte.",
    icon: Martini,
  },
];

export const Momenti = () => (
  <section id="momenti" className="scroll-mt-20 bg-espresso py-20 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <Eyebrow>I Momenti della Giornata</Eyebrow>
        <h2 className="mt-4 max-w-2xl text-balance font-serif text-3xl font-semibold tracking-tight text-cream sm:text-4xl lg:text-5xl">
          Un giorno, tre modi d'incontrarsi.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {MOMENTS.map((m, i) => (
          <Reveal key={m.time} delay={i * 0.1}>
            <article className="group relative border-t border-sand/20 pt-6 transition-colors duration-500 hover:border-terra">
              <span className="font-mono text-sm tracking-[0.2em] text-terra-light">
                {m.time}
              </span>
              <m.icon className="mt-6 size-6 text-sand/70 transition-colors duration-500 group-hover:text-terra-light" />
              <h3 className="mt-4 font-serif text-xl font-semibold leading-snug text-cream">
                {m.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/60">
                {m.text}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
